<!--获取云停车场设备信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode":"PR2WCYG4"
            },
            responseCode: 	{"data":{
        "recordList": [
            {
                "channelConfigVo": {
                    "channelID": 3,
                    "deviceVolume": 50,
                    "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[],[]]}",
                    "entranceName": "废弃出口12",
                    "parkGlobalID": "f034cc92-1680-4be6-9026-c174496ea7df"
                }
            },
            {
                "channelConfigVo": {
                    "channelID": 7,
                    "deviceVolume": 34,
                    "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[\"%PTDM\",\"park-config/protocol/233c82a0-5e7c-4a8d-aa3a-c958f6f6bdb7.png\"]]}",
                    "entranceName": "测试停车场出口",
                    "parkGlobalID": "f034cc92-1680-4be6-9026-c174496ea7df"
                },
                "ytjDeviceVo": {
                    "assistStatus": 0,
                    "gateWayChangeFlag": false,
                    "gateway": "10.10.0.1",
                    "ip": "10.10.114.103",
                    "ipChangeFlag": false,
                    "ipModel": 1,
                    "ipModelChangeFlag": false,
                    "mask": "255.255.0.0",
                    "maskChangeFlag": false,
                    "rssi": 0,
                    "status": 0,
                    "ytj_id": "00000000000000000002",
                    "ytj_name": "测试停车场出口一体机",
                    "ytj_seq": 149
                }
            },
            {
                "channelConfigVo": {
                    "channelID": 2334,
                    "deviceVolume": 56,
                    "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[\"%PTDM\",\"clound-oss/park-config/channel-display/f034cc92-1680-4be6-9026-c174496ea7df_2334.jpg\"]]}",
                    "entranceName": "wangjian虚拟进口12",
                    "parkGlobalID": "f034cc92-1680-4be6-9026-c174496ea7df"
                }
            },
            {
                "channelConfigVo": {
                    "channelID": 2335,
                    "deviceVolume": 53,
                    "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[],[]]}",
                    "entranceName": "wangjian虚拟出口1",
                    "parkGlobalID": "f034cc92-1680-4be6-9026-c174496ea7df"
                }
            },
            {
                "channelConfigVo": {
                    "channelID": 2344,
                    "customCode": "DQZYJK",
                    "deviceVolume": 50,
                    "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[\"%PTQR\"]]}",
                    "entranceName": "东强专用进口",
                    "parkGlobalID": "f034cc92-1680-4be6-9026-c174496ea7df"
                },
                "ytjDeviceVo": {
                    "assistStatus": 0,
                    "gateWayChangeFlag": false,
                    "gateway": "10.10.0.1",
                    "ip": "10.10.114.112",
                    "ipChangeFlag": false,
                    "ipModel": 1,
                    "ipModelChangeFlag": false,
                    "mask": "255.255.0.0",
                    "maskChangeFlag": false,
                    "rssi": 0,
                    "status": 0,
                    "ytj_id": "18030002CF5A",
                    "ytj_name": "东强专用进口一体机",
                    "ytj_seq": 148
                }
            },
            {
                "channelConfigVo": {
                    "channelID": 2345,
                    "customCode": "",
                    "deviceVolume": 50,
                    "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[],[]]}",
                    "entranceName": "东强专用出口",
                    "parkGlobalID": "f034cc92-1680-4be6-9026-c174496ea7df"
                },
                "ytjDeviceVo": {
                    "assistStatus": 0,
                    "gateWayChangeFlag": false,
                    "gateway": "10.10.0.1",
                    "ip": "172.18.1.121",
                    "ipChangeFlag": false,
                    "ipModel": 1,
                    "ipModelChangeFlag": false,
                    "mask": "255.255.0.0",
                    "maskChangeFlag": false,
                    "rssi": 0,
                    "status": 0,
                    "ytj_id": "8C89A53B7CA5",
                    "ytj_name": "东强专用出口一体机",
                    "ytj_seq": 147
                }
            },
            {
                "channelConfigVo": {
                    "channelID": 2423,
                    "customCode": "DQZYJK1",
                    "deviceVolume": 50,
                    "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[\"%PTQR\"]]}",
                    "entranceName": "测试子区域入口",
                    "parkGlobalID": "f034cc92-1680-4be6-9026-c174496ea7df"
                }
            },
            {
                "channelConfigVo": {
                    "channelID": 2424,
                    "customCode": "",
                    "deviceVolume": 50,
                    "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[],[]]}",
                    "entranceName": "测试子区域出口",
                    "parkGlobalID": "f034cc92-1680-4be6-9026-c174496ea7df"
                }
            },
            {
                "channelConfigVo": {
                    "channelID": 2462,
                    "customCode": "",
                    "deviceVolume": 50,
                    "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[],[]]}",
                    "entranceName": "模拟区域入口1（勿删）",
                    "parkGlobalID": "f034cc92-1680-4be6-9026-c174496ea7df"
                }
            },
            {
                "channelConfigVo": {
                    "channelID": 2463,
                    "customCode": "",
                    "deviceVolume": 74,
                    "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[],[]]}",
                    "entranceName": "模拟区域入口2（勿删）",
                    "parkGlobalID": "f034cc92-1680-4be6-9026-c174496ea7df"
                },
                "ytjDeviceVo": {
                    "assistStatus": 0,
                    "gateWayChangeFlag": false,
                    "gateway": "",
                    "ip": "",
                    "ipChangeFlag": false,
                    "ipModel": 0,
                    "ipModelChangeFlag": false,
                    "mask": "",
                    "maskChangeFlag": false,
                    "rssi": 0,
                    "status": 0,
                    "ytj_id": "10000000000000000001",
                    "ytj_name": "压力测试入口1",
                    "ytj_seq": 30
                }
            },
            {
                "channelConfigVo": {
                    "channelID": 2464,
                    "customCode": "",
                    "deviceVolume": 50,
                    "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[],[]]}",
                    "entranceName": "模拟区域出口1（勿删）",
                    "parkGlobalID": "f034cc92-1680-4be6-9026-c174496ea7df"
                }
            },
            {
                "channelConfigVo": {
                    "channelID": 2465,
                    "customCode": "",
                    "deviceVolume": 50,
                    "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[],[]]}",
                    "entranceName": "模拟区域出口2（勿删）",
                    "parkGlobalID": "f034cc92-1680-4be6-9026-c174496ea7df"
                },
                "ytjDeviceVo": {
                    "assistStatus": 0,
                    "gateWayChangeFlag": false,
                    "gateway": "",
                    "ip": "",
                    "ipChangeFlag": false,
                    "ipModel": 0,
                    "ipModelChangeFlag": false,
                    "mask": "",
                    "maskChangeFlag": false,
                    "rssi": 0,
                    "status": 0,
                    "ytj_id": "10000000000000000002",
                    "ytj_name": "压力测试入口2",
                    "ytj_seq": 31
                }
            },
            {
                "channelConfigVo": {
                    "channelID": 2902,
                    "customCode": "CSTCCJK",
                    "deviceVolume": 0,
                    "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[\"%PTQR\"]]}",
                    "entranceName": "测试停车场进口",
                    "parkGlobalID": "f034cc92-1680-4be6-9026-c174496ea7df"
                },
                "ytjDeviceVo": {
                    "assistStatus": 0,
                    "gateWayChangeFlag": false,
                    "gateway": "10.10.0.1",
                    "ip": "10.10.114.105",
                    "ipChangeFlag": false,
                    "ipModel": 1,
                    "ipModelChangeFlag": false,
                    "mask": "255.255.0.0",
                    "maskChangeFlag": false,
                    "rssi": 0,
                    "status": 0,
                    "ytj_id": "28117002",
                    "ytj_name": "测试停车场进口一体机",
                    "ytj_seq": 152
                }
            },
            {
                "channelConfigVo": {
                    "channelID": 3101,
                    "customCode": "2KR2RP2L",
                    "deviceVolume": 50,
                    "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[],[]]}",
                    "entranceName": "zzt入口",
                    "parkGlobalID": "f034cc92-1680-4be6-9026-c174496ea7df"
                }
            },
            {
                "channelConfigVo": {
                    "channelID": 3102,
                    "customCode": "2KR2RP2M",
                    "deviceVolume": 50,
                    "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[\"%PTDM\",\"clound-oss/park-config/channel-display/f034cc92-1680-4be6-9026-c174496ea7df_3102.jpg\"]]}",
                    "entranceName": "zzt出口",
                    "parkGlobalID": "f034cc92-1680-4be6-9026-c174496ea7df"
                }
            },
            {
                "channelConfigVo": {
                    "channelID": 3121,
                    "customCode": "2KR3X2A9",
                    "deviceVolume": 50,
                    "displayContent": "{\"displayContentArray\":[[\"%CN\"],[\"%T\"],[],[]]}",
                    "entranceName": "123456",
                    "parkGlobalID": "f034cc92-1680-4be6-9026-c174496ea7df"
                }
            }
        ]
    },"message":"业务成功","resultCode":0,"status":1},
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取云停车场设备信息",
                t_url: this.commonUrls.test+"getCloudParkDeviceInfo",
                p_url: this.commonUrls.prod+"getCloudParkDeviceInfo",
                precondition: "",
                fitSystem: "云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '通道信息列表' },
                        { info1: 'parkEquipmentEnvironmentCameraVoList', info2: '否', info3: 'JSONArray', info4: '环境枪信息列表' },

                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'ChannelConfigVo', info2: '是', info3: 'JSONObject', info4: '通道配置实体' },
                        { info1: 'YtjDeviceVo', info2: '否', info3: 'JSONObject', info4: '这个通道绑定的一体机设备' },
                        { info1: 'BoxDeviceVo', info2: '否', info3: 'JSONObject', info4: '这个通道绑定的盒子设备' },
                        { info1: 'cameraConfigVoList', info2: '否', info3: 'JSONArrary', info4: '这个通道绑定的摄像枪设备列表' },
                        { info1: 'deviceExceptionStatus', info2: '是', info3: 'boolean', info4: '读取底层设备状态是否出现异常 true 是 false否  一般情况不用考虑,除非读取底层无响应. 如果是的话 那这个通道的设备就全部异常 这个标记是为了防止调用底层无响应的情况 能在界面呈现 控制有设备的情况下不让调试，以及状态展示 ' },
                        { info1: 'changeFlag', info2: '是', info3: 'boolean', info4: '是否发生变化' },
                        { info1: 'deviceModel', info2: '否', info3: 'Integer', info4: '当前通道的设备模式 0dhcp(自动) 1静态分配(手动) 创建车场默认自动' },
                        ]
                },{
                    titleName: 'ChannelConfigVo',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'channelID', info2: '是', info3: 'Long', info4: '通道ID' },
                        { info1: 'parkGlobalID', info2: '否', info3: 'String', info4: '停车场主键编号,32位UUID' },
                        { info1: 'entranceName', info2: '是', info3: 'String', info4: '通道名称' },
                        { info1: 'customCode', info2: '是', info3: 'String', info4: '自定义通道编码' },
                        { info1: 'displayContent', info2: '是', info3: 'String', info4: '显示屏空闲显示内容 实际存储占位符' },
                        { info1: 'deviceVolume', info2: '是', info3: 'Integer', info4: '设备音量 0-100 默认50' },
                        ]
                },{
                    titleName: 'YtjDeviceVo',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'ytj_seq', info2: '是', info3: 'Long', info4: '一体机自增序号' },
                        { info1: 'ytj_name', info2: '否', info3: 'String', info4: '一体机名称' },
                        { info1: 'ip', info2: '是', info3: 'String', info4: '一体机IP' },
                        { info1: 'mask', info2: '是', info3: 'String', info4: '子网掩码' },
                        { info1: 'gateway', info2: '是', info3: 'String', info4: '默认网关' },
                        { info1: 'ytj_id', info2: '是', info3: 'Integer', info4: '一体机全球唯一id' },
                        { info1: 'rssi', info2: '是', info3: 'Long', info4: '辅链路 4G信号强度0-100' },
                        { info1: 'assistStatus', info2: '否', info3: 'String', info4: '辅链路 4G网络状态 0离线 1在线' },
                        { info1: 'status', info2: '是', info3: 'String', info4: '主链路 有线网络状态 0离线 1在线' },
                        { info1: 'ipModel', info2: '是', info3: 'String', info4: 'IP模式（0DHCP自动获取，1固定IP）' },
                        { info1: 'ipModelChangeFlag', info2: '是', info3: 'String', info4: 'ip设置模式是否变化' },
                        { info1: 'ipChangeFlag', info2: '是', info3: 'String', info4: 'ip是否变化' },
                        { info1: 'maskChangeFlag', info2: '是', info3: 'Integer', info4: '子网掩码是否变化' },
                        { info1: 'gateWayChangeFlag', info2: '是', info3: 'Integer', info4: '网关是否变化' },
                        ]
                },
                {
                    titleName: 'boxDeviceVo',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'Long', info4: '盒子自增id' },
                        { info1: 'boxName', info2: '是', info3: 'Long', info4: '盒子名称' },
                        { info1: 'boxId', info2: '否', info3: 'String', info4: '盒子id' },
                        { info1: 'ip', info2: '是', info3: 'String', info4: '盒子IP' },
                        { info1: 'mask', info2: '是', info3: 'String', info4: '子网掩码' },
                        { info1: 'gateway', info2: '是', info3: 'String', info4: '默认网关' },
                        { info1: 'ytj_id', info2: '是', info3: 'Integer', info4: '一体机全球唯一id' },
                        { info1: 'rssi', info2: '是', info3: 'Long', info4: '辅链路 4G信号强度0-100' },
                        { info1: 'assistStatus', info2: '否', info3: 'String', info4: '辅链路 4G网络状态 0离线 1在线' },
                        { info1: 'status', info2: '是', info3: 'String', info4: '主链路 有线网络状态 0离线 1在线' },
                        { info1: 'ipModel', info2: '是', info3: 'String', info4: 'IP模式（0DHCP自动获取，1固定IP）' },
                        { info1: 'ipModelChangeFlag', info2: '是', info3: 'String', info4: 'ip设置模式是否变化' },
                        { info1: 'ipChangeFlag', info2: '是', info3: 'String', info4: 'ip是否变化' },
                        { info1: 'maskChangeFlag', info2: '是', info3: 'Integer', info4: '子网掩码是否变化' },
                        { info1: 'gateWayChangeFlag', info2: '是', info3: 'Integer', info4: '网关是否变化' },
                        ]
                },
                {
                    titleName: 'CameraConfigVo',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'Long', info4: '摄像枪自增ID' },
                        { info1: 'cameraName', info2: '是', info3: 'Long', info4: '摄像枪名称' },
                        { info1: 'cameraID', info2: '否', info3: 'String', info4: '摄像枪全球唯一ID' },
                        { info1: 'cameraIp', info2: '是', info3: 'String', info4: '扫码设备返回的IP' },
                        { info1: 'cameraMask', info2: '是', info3: 'Long', info4: '扫码设备返回的子网掩码' },
                        { info1: 'cameraGateway', info2: '否', info3: 'String', info4: '扫码返回的默认网关' },
                        { info1: 'status', info2: '是', info3: 'String', info4: '网络状态 0离线 1在线' },
                        { info1: 'ezvizParam', info2: '是', info3: 'String', info4: '萤石云相关参数' },
                        { info1: 'ezvizAfterParam', info2: '是', info3: 'String', info4: '萤石云播放参数' },
                        { info1: 'idChangeFlag', info2: '是', info3: 'String', info4: 'id是否变化' },
                        { info1: 'ipChangeFlag', info2: '是', info3: 'String', info4: 'ip是否变化' },
                        { info1: 'maskChangeFlag', info2: '是', info3: 'Integer', info4: '子网掩码是否变化' },
                        { info1: 'gateWayChangeFlag', info2: '是', info3: 'Integer', info4: '网关是否变化' },
                        ]
                },
                {
                    titleName: 'parkEquipmentEnvironmentCameraVoList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'Long', info4: '环境枪自增ID' },
                        { info1: 'parkId', info2: '否', info3: 'String', info4: '停车场UUID' },
                        { info1: 'cameraIp', info2: '否', info3: 'String', info4: '环境枪IP' },
                        { info1: 'channelIdList', info2: '否', info3: 'JSONArray', info4: '关联通道列表ID [1,2,3]' },
                        { info1: 'appKey', info2: '否', info3: 'String', info4: '萤石云应用参数，appKey ' },
                        { info1: 'secret', info2: '否', info3: 'String', info4: '萤石云应用参数，secret' },
                        { info1: 'ezvizParam', info2: '否', info3: 'String', info4: '萤石云相关参数' },
                        { info1: 'ezvizAfterParam', info2: '否', info3: 'String', info4: '萤石云播放参数 视频流地址' },
             
                        ]
                },
            ],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/park/getCloudParkDeviceInfo.vue